'use client';

import Image from 'next/image';
import Link from 'next/link';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { MentorshipListProgramView } from '@/features/mentorship';

import 'swiper/css';
import 'swiper/css/navigation';
import './mentorship-list-hero.css';

type Props = {
  programs: MentorshipListProgramView[];
};

export default function MentorshipListHero({ programs }: Props) {
  const canLoop = programs.length > 1;

  return (
    <div className="mentorship-list-hero relative w-full overflow-hidden h-auto">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        loop={canLoop}
        autoplay={
          canLoop
            ? {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }
            : false
        }
        className="mentorship-list-hero__swiper w-full h-auto"
      >
        {programs.map((program) => (
          <SwiperSlide key={program.id} className="relative h-auto">
            <div className="relative w-full bg-gray-100 aspect-1920/550">
              <Link
                href={`/mentorship/${program.id}`}
                className="absolute inset-0 block"
              >
                <Image
                  src={program.heroBackgroundUrl}
                  alt={program.heroTitleAlt || program.listTitle}
                  fill
                  sizes="100vw"
                  className="object-fit"
                  priority={program.id === programs[0]?.id}
                />
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
